/* eslint-disable check-credentials-option/has-credentials-option */
import { cfetch } from '@confluence/network';
import { getSSRRenderInputs } from '@confluence/ssr-utilities/entry-points/ssrRenderInputs.ts';

import { createCookie } from './createCookie.ts';

interface FetchORSType {
	userContext: string | undefined;
	url: string;
	body: string;
}

export const fetchORSForSSR = async ({ url, userContext, body }: FetchORSType): Promise<any> => {
	const { host, cloudId } = getSSRRenderInputs();
	const fetchOptions = {
		method: 'POST',
		headers: {
			Cookie: createCookie(userContext),
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Origin: host.startsWith('http') ? host : `https://${host}`,
			CloudId: cloudId,
			'X-Product': 'CONFLUENCE',
		},
		body,
	};

	return cfetch(url, fetchOptions);
};
